/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { AppContext } from '../../App';
import BetSelector from '../../common/BetSelector';
import CategorySelector from '../../common/CategorySelector';
import ExpandedViewProvider from '../../common/ExpandedViewProvider';
import ExpandedViewToggle from '../../common/ExpandedViewToggle';
import FastbetToggle from '../../common/fast-bet/FastbetToggle';
import Loader from '../../common/Loader';
import MessageInfo from '../../common/MessageInfo';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { GROUPED_VIEW_MARKETS } from '../../data/constants';
import { useFetchMenuLiveGenerale } from '../../data/fetchMenuLiveGenerale';
import { useFetchSeoSettings } from '../../data/fetchSeoSettings';
import { SeoContext } from '../../data/seo/SeoContextProvider';
import SeoMainContainer from '../../data/seo/SeoMainContainer';
import SeoMetaTags from '../../data/seo/SeoMetaTags';
import { useHandleSeoSettings } from '../../data/seo/seoUtils';
import { setBetslipEventsNumber, setLiveEventsNumber } from '../../data/sport-utils';
import { getMatchStreamingProps } from '../../data/streaming/streamingUtils';
import { classIf } from '../../data/utils/classIf';
import { filtraParametriche } from '../../data/utils/filtraParametriche';
import { getConfiguration } from '../../data/utils/configuration';
import { getLiveAggs } from '../../data/utils/getLiveAggs';
import { getPrincipaleOPrimoGruppo } from '../../data/utils/getPrincipaleOPrimoGruppo';
import { labels } from '../../data/labels';
import { isOverlaySection } from '../../utils/sport-effects';
import { LiveContext } from '../Live';
import LiveTournamentMatch from '../tournament/LiveTournamentMatch';
import LiveTournament from './../tournament/LiveTournament';
import LiveSporstNav from './LiveSportsNav';

function LiveSuite(props) {  
    const appContext = React.useContext(AppContext);
    const liveContext = React.useContext(LiveContext);
    const seoContext = React.useContext(SeoContext);
    const betslipContext = React.useContext(BetslipContext);

    const [sportId, setSportId] = useState(props.sport);
    const [currentSport, setCurrentSport] = useState(null);
    const [category, setCategory] = useState(null);
    const [categories, setCategories] = useState(null);
    const [tournaments, setTournaments] = useState(null);
    const [showLoader, setShowLoader] = useState(true);
    const conf = getConfiguration();
    const bettingClosedMessage = `${labels['general.eventi_live']} ${labels['general.chiuso']}`;
   
    const [seoSettingsState] = useFetchSeoSettings(seoContext.pathname,true,conf.seo);

    useHandleSeoSettings(seoSettingsState);
    
    const [state, , isSetInterval] = useFetchMenuLiveGenerale(sportId, true);

    useEffect(() => {
        if(!state.isLoading && state.data != null) {
            const firstSport = state.data.sport.filter(s => s.id === sportId)[0] || state.data.sport[0];
            const firstCategory = firstSport && firstSport.categories[0];
            if (currentSport == null || firstSport.id !== currentSport.id) {
                setCurrentSport(firstSport);
            }

            // Aggiorno tornei nazione corrente, se nazione non c'e' (catch) mi posiziono su prima nazione
            try {
                const categoryId = category != null ? category.id : firstCategory.id;
                setTournaments(state.data.sportById[firstSport.id].categoryById[categoryId].tournaments);
            } catch(err) {
                if (firstCategory) {
                    changeCategory(firstCategory.id);
                }
            }
            liveContext.setSports(state.data.sport);
        }
        setLiveEventsNumber(state.data?.nel);
    }, [state.data]);

    useEffect(() => {
       if (currentSport) {
            setCategories(state.data.sportById[currentSport.id].categories);
            setCategory(state.data.sportById[currentSport.id].categories[0]);
       }
    }, [currentSport]);

    useEffect(() => {
        if(category){
            liveContext.setTournaments(category.tournaments);
            setTournaments(category.tournaments);
        }
     }, [category]);

     useEffect(() => {
        if(betslipContext.betslipData)
            setBetslipEventsNumber(betslipContext.getCouponSelectionsNum());
     }, [betslipContext.betslipData]);
     

    function changeSport(id) {
        setSportId(id);
        liveContext.changeBet(null);
        //liveContext.resetBetsCollapsedState();
        setShowLoader(false);
    }

    function changeCategory(id) {
        if ((state.data.sportById[currentSport.id].categoryById)) {
            setCategory(state.data.sportById[currentSport.id].categoryById[id]);
        }
    }

    function handleChangeBet(bet) {
        liveContext.changeBet(bet);
    }

    function handleExpand() {
        liveContext.setExpandedView(!liveContext.expandedView);
    }

    if (!state.isLoading && (state.data == null || Object.keys(state.data).length === 0)) {
        return (
            <MessageInfo message={bettingClosedMessage} hide={appContext.showBetslip} />
        );
    } else if ((!isSetInterval && showLoader && state.isLoading) || state.data == null || state.isError) {
        return <Loader error={state.isError} hide={appContext.showBetslip} />;
    }

    const firstTournament = tournaments && tournaments[0];
    let bets = firstTournament?.events[0].bets ?? null;
    bets = bets && filtraParametriche(bets);

    let elementsList = null;
    if (tournaments) {
        if (liveContext.sortType === 'league') {
            elementsList = tournaments.map(function(tournament){
                return <LiveTournament key={tournament.uniqueId}  {...tournament} sport={currentSport} country={currentSport.categoryById[tournament.categoryRef]} />
            });
        } else {
            const matches = [];
            tournaments.forEach(tournament => {
                tournament.events.forEach(match => {
                    const aggregata = getPrincipaleOPrimoGruppo(tournament.aggregate).idAggregata;
                    match.openAggregata = aggregata;
                    matches.push(match);
                });
            });
            matches.sort((m1, m2) => {
                if (liveContext.sortType === 'asc') {
                    return m1.timestamp.getTime() - m2.timestamp.getTime();
                } else {
                    return m2.timestamp.getTime() - m1.timestamp.getTime();
                }
            });
            elementsList = matches.map(function(match) {
                const streamingMap = getMatchStreamingProps(match);
                return <LiveTournamentMatch key={match.uniqueId} match={match} aggregata={match.openAggregata} streaming={streamingMap && streamingMap[match.id]}  />
            });
        }
    }

    const hideWrapper = isOverlaySection(appContext,props.section);

    if (state.data == null) {
        return (
            <MessageInfo message={bettingClosedMessage} />
        );
    }

    let groupedView = false;
    if (bets?.length === 1 && GROUPED_VIEW_MARKETS.includes(bets[0].cs)) {
        groupedView = true;
    }

    return (
        <ExpandedViewProvider>
            <SeoMetaTags />
            <div id="main-wrapper" className={"wrapper" + classIf(hideWrapper, 'no-scroll d-none')}>
                <div id="main-container" className="main-content live-suite">
                    <div className={"navbars-container" + classIf(liveContext.expandedView === true, 'expanded-view')}>
                        <LiveSporstNav sports={state.data.sport} currentSport={currentSport} changeSport={changeSport} />
                        <CategorySelector categories={categories} category={category} changeCountry={changeCategory} />
                        {!liveContext.expandedView && bets && 
                            <BetSelector bets={bets} bet={liveContext.bet || bets[0]} changeBet={handleChangeBet} isLive={true}/>
                        }
                        <nav id="nav-vista-estesa" className="small">
                            {conf.anbe &&
                                <FastbetToggle />
                            }
                            {groupedView ?
                                <ExpandedViewToggle />
                                :
                                <div className="d-flex push-right">
                                    <label className="custom-switch-2 mr-2">
                                        <input type="checkbox" checked={liveContext.expandedView === true} onChange={handleExpand} />
                                        <span className="custom-slider-2 round"></span>
                                    </label>
                                    <span>{labels['general.expanded_view']}</span>
                                </div>
                            }
                        </nav>
                    </div>
                    <div className={"live-suite-events" + classIf(liveContext.expandedView === true, 'expanded-view')}>
                        {elementsList}
                    </div>
                </div>
                <SeoMainContainer />          
            </div>  
        </ExpandedViewProvider>
    );
}

export default LiveSuite;